<template>
    <div class="TQ_center">

        <!-- errors -->
        <div class="TQ_padding_8px TQ_width_100p TQ_scrollable_horizontal TQ_borderBox TQ_maxHeight_80vh TQ_padding_8px">

            <table class="TQ_border TQ_padding_8px TQ_direction_ltr TQ_bg_white TQ_width_100p TQ_borderBox  ">

                <tr class="TQ_border TQ_bg_gray4 TQ_text_capitalize">
                    <th class="TQ_border">#</th>
                    <th class="TQ_border">time</th>
                    <th class="TQ_border">eventsNum</th>

                    <th class="TQ_border">viewName</th>
                    <th class="TQ_border">name</th>
                    <th class="TQ_border">msg</th>

                    <th class="TQ_border">runIn</th>
                    <th class="TQ_border">fullRoute</th>

                    <th class="TQ_border">OngoingEventInfo</th>
                    <th class="TQ_border">viewInfo</th>



                    <th class="TQ_border">usersId</th>
                    <th class="TQ_border">stack</th>
                </tr>

                <tr v-for="(error_oac, key_s) in co_errors_byStack_ac" class="TQ_border TQ_align_initial">
                    <td class="TQ_border TQ_center">{{key_s}}</td>

                    <td class="TQ_border TQ_textLineBreak TQ_direction_rtl TQ_center">
                        <div class="TQ_text_bold">{{format_date_YYYY_MM_DD_hh_mm_fs(error_oac.lastDate_t)}}</div>
                        <div>---------------</div>
                        <div>{{format_date_YYYY_MM_DD_hh_mm_fs(error_oac.firstDate_t)}}</div>
                    </td>
                    <td class="TQ_border TQ_center">{{error_oac.total_n}}</td>
                    <td class="TQ_border ">{{error_oac.viewName_s}}</td>
                    <td class="TQ_border">{{error_oac.name_s}}</td>
                    <td class="TQ_border">{{error_oac.msg_s}}</td>

                    <td class="TQ_border">{{Object.values(error_oac.runIn_byRunIn_ae)}}</td>
                    <td class="TQ_border">{{Object.values(error_oac.fullRoute_fullRoute_e)}}</td>

                    <td class="TQ_border">{{Object.values(error_oac.questInfo_byQuestInfo_s)}}</td>
                    <td class="TQ_border">{{Object.values(error_oac.viewInfo_byViewInfo_s)}}</td>


                    <td class="TQ_border TQ_text_12px">
                        <div> {{ (expandUsersIds_byStack_b[key_s] ? error_oac.usersId_as : error_oac.usersId_as.slice(0,3))}}</div>
                        <span @click="$set(expandUsersIds_byStack_b, key_s, !expandUsersIds_byStack_b[key_s])" v-if="error_oac.usersId_as.length>3" class="TQ_textColor_red TQ_clickable TQ_text_bold" >{{expandUsersIds_byStack_b[key_s] ? 'Show Less' : 'Show More'}} ({{error_oac.usersId_as.length }})</span>
                    </td>
                    <td class="TQ_border TQ_text_12px ">
                        <div class="TQ_textLineBreak">{{expandStack_byStack_b[key_s] ? error_oac.stackList_s : format_strMaxLength_s(error_oac.stackList_s, 100)}}</div>
                        <span class="TQ_textColor_red TQ_clickable TQ_text_bold" @click="$set(expandStack_byStack_b, key_s, !expandStack_byStack_b[key_s])">{{expandStack_byStack_b[key_s] ? 'Show Less' : 'Show More'}}</span>
                    </td>
                </tr>

                <tr v-if="co_errors_byStack_ac === {}" class="TQ_text_24px TQ_text_bold">
                    <td colspan="8" class="TQ_border">
                        No Errors
                    </td>
                </tr>
            </table>

        </div>

        <!-- btn -->
        <tq-loader-button :show-loader="btnLoader_b">
            <div @click="m_getAllErrors_f" class="TQ_unselectable TQ_inline TQ_bg_green TQ_borderRadius TQ_padding_8px TQ_clickable TQ_margin_top_16px TQ_box_shadow2">
                Get All Errors
            </div>
        </tq-loader-button>


    </div>
</template>

<script>
    import {serverPre_errors_getAll_f} from "@/scripts/Server/S_ServerPre";
    import {format_date_YYYY_MM_DD_hh_mm_fs, format_strMaxLength_s} from "../../../functions/src/shareCode/Share_S_Format";
    import {
        date_newDate_fd,
    } from "@/scripts/S_Date";
    import TqLoaderButton from "@/components/basic2/TqLoaderButton";

    export default {
        name: "v_Admin_Errors",
        components: {TqLoaderButton},
        data(){
            return {
                errors_ac : [],
                btnLoader_b : false,
                expandStack_byStack_b : {},
                expandUsersIds_byStack_b : {},

                format_strMaxLength_s : format_strMaxLength_s,
                format_date_YYYY_MM_DD_hh_mm_fs : format_date_YYYY_MM_DD_hh_mm_fs,
            }
        },

        computed:{
            co_errors_byStack_ac(){
                let errors_byStack_oac = {}

                this.errors_ac.forEach(error_c => {
                    let stack_s = error_c.err_viewName_s + error_c.err_name_s + error_c.err_msg_s
                    let questInfo = "questType=" + error_c.err_ongoingQuestType_e + ",questId=" +  error_c.err_ongoingQuestId_uid + ",eventId="+ error_c.err_ongoingEventId_uid

                    if(errors_byStack_oac[stack_s] == null) {
                        errors_byStack_oac[stack_s] = {
                            total_n     : 0,
                            viewName_s  : error_c.err_viewName_s,
                            name_s      : error_c.err_name_s,
                            msg_s       : error_c.err_msg_s,
                            runIn_byRunIn_ae    : {[error_c.err_runIn_e]: error_c.err_runIn_e},
                            fullRoute_fullRoute_e    : {[error_c.err_fullRoute_e]: error_c.err_fullRoute_e},
                            viewInfo_byViewInfo_s    : {[error_c.err_viewInfo_s]: error_c.err_viewInfo_s},
                            stack_byStack_s    : {[error_c.err_stack_s]: error_c.err_stack_s},
                            questInfo_byQuestInfo_s    : {[questInfo]: questInfo},
                            firstDate_t : error_c.err_time_t,
                            lastDate_t  : error_c.err_time_t,
                            userId_byUserId_uid  : {[error_c.err_userId_uid] : error_c.err_userId_uid},
                            errors_ac   : [error_c],

                        }
                    }else{
                        errors_byStack_oac[stack_s].total_n++
                        errors_byStack_oac[stack_s].runIn_byRunIn_ae[error_c.err_runIn_e] =error_c.err_runIn_e
                        errors_byStack_oac[stack_s].fullRoute_fullRoute_e[error_c.err_fullRoute_e] =error_c.err_fullRoute_e
                        errors_byStack_oac[stack_s].questInfo_byQuestInfo_s[questInfo] =questInfo
                        errors_byStack_oac[stack_s].viewInfo_byViewInfo_s[error_c.err_viewInfo_s] =error_c.err_viewInfo_s
                        errors_byStack_oac[stack_s].stack_byStack_s[error_c.err_stack_s] =error_c.err_stack_s
                        errors_byStack_oac[stack_s].userId_byUserId_uid[error_c.err_userId_uid] =error_c.err_userId_uid

                        errors_byStack_oac[stack_s].errors_ac.push(error_c)

                        if(errors_byStack_oac[stack_s].firstDate_t > error_c.err_time_t){
                            errors_byStack_oac[stack_s].firstDate_t = error_c.err_time_t
                        }
                        if(errors_byStack_oac[stack_s].lastDate_t < error_c.err_time_t){
                            errors_byStack_oac[stack_s].lastDate_t = error_c.err_time_t
                        }
                    }
                })
                let errors_aoac = Object.values(errors_byStack_oac)
                errors_aoac.forEach(error_o => {
                    error_o.stackList_s = "" + Object.values(error_o.stack_byStack_s)
                    error_o.usersId_as = Object.values(error_o.userId_byUserId_uid)
                })

                errors_aoac = errors_aoac.sort((item1, item2) => item1.lastDate_t < item2.lastDate_t ? 1 : -1)

                return errors_aoac
            }
        },
        methods:{
            m_getAllErrors_f(){
                this.btnLoader_b = true
                let prevMonth_n = date_newDate_fd().getMonth()
                let currentYear_s = date_newDate_fd().getFullYear()
                serverPre_errors_getAll_f({
                    startDate_t : (new Date(currentYear_s, prevMonth_n-1)).getTime(),
                    endDate_n: (new Date).getTime(),
                    cb_f : (errors_ac) => {
                        this.btnLoader_b = false
                        this.errors_ac = errors_ac
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    table td, table td * {
        vertical-align: top;
    }
</style>